import Web3 from "web3";

// 初始化 Web3 实例
const web3 = (rpcUrl) => {
	return new Web3(new Web3.providers.HttpProvider(rpcUrl));
}

export default web3;
